// src/locales/en.js
const lang = {
   
  };

  export default  lang;